const handleCharactersKeyDown = (e) => {
  if (
    !/[a-zA-Z ]/.test(e.key) && // Allow only letters and space
    e.key !== "Backspace" &&     // Allow backspace
    e.key !== "Delete" &&        // Allow delete
    e.key !== "ArrowLeft" &&     // Allow left arrow
    e.key !== "ArrowRight" &&    // Allow right arrow
    e.key !== "Tab"              // Allow tab
  ) {
    e.preventDefault();
  }
};

const handleKeyDown = (e) => {
  if (
    !/[0-9]/.test(e.key) && // Allow only numbers
    e.key !== "Backspace" && // Allow backspace
    e.key !== "Delete" && // Allow delete
    e.key !== "ArrowLeft" && // Allow left arrow
    e.key !== "ArrowRight" && // Allow right arrow
    e.key !== "Tab" // Allow tab
  ) {
    e.preventDefault();
  }
};

const handleNameKeyDown = (e) => {
  const allowedKeys = [
    "Backspace",
    "Delete",
    "ArrowLeft",
    "ArrowRight",
    "Tab",
    " "
  ];

  const key = e.key;
  const isAlphabet = /^[a-zA-Z]$/.test(key);
  const isAllowedKey = allowedKeys.includes(key);

  if (!isAlphabet && !isAllowedKey) {
    e.preventDefault();
  }
};




const handlePriceKeyDown = (e) => {
  const input = e.target.value;

  // Allow control keys
  if (
    e.key === "Backspace" ||
    e.key === "Delete" ||
    e.key === "ArrowLeft" ||
    e.key === "ArrowRight" ||
    e.key === "Tab" ||
    e.ctrlKey ||
    e.metaKey
  ) {
    return;
  }

  // Allow numbers
  if (/[0-9]/.test(e.key)) {
    // Check if we're adding a digit after decimal point
    if (input.includes('.')) {
      const decimalPart = input.split('.')[1];
      if (decimalPart && decimalPart.length >= 2) {
        e.preventDefault();
        return;
      }
    } else {
      // Check total digits before decimal (including the new one)
      const integerPart = input.split('.')[0];
      if (integerPart && integerPart.replace(/[^0-9]/g, '').length >= 12) {
        e.preventDefault();
        return;
      }
    }
    return;
  }

  // Allow decimal point only if not already present and there are digits before it
  if (e.key === '.' && !input.includes('.') && input.length > 0 && /[0-9]/.test(input[input.length - 1])) {
    return;
  }

  // Prevent all other keys
  e.preventDefault();
};


const nomorethenhandread = (e) => {
  const inputValue = e.target.value;

  // Check if the current value plus the new digit would exceed 100
  if (
    parseInt(inputValue + e.key) > 100 &&
    e.key !== "Backspace" &&
    e.key !== "Delete"
  ) {
    e.preventDefault();
  }

  // Allow only numbers and control keys
  if (
    !/[0-9]/.test(e.key) && // Allow only numbers
    e.key !== "Backspace" && // Allow backspace
    e.key !== "Delete" && // Allow delete
    e.key !== "ArrowLeft" && // Allow left arrow
    e.key !== "ArrowRight" && // Allow right arrow
    e.key !== "Tab" // Allow tab
  ) {
    e.preventDefault();
  }
};

const notallowspace = (e) => {
  if (e.key == " ") {
    // Check if the key is a spacebar
    e.preventDefault(); // Prevent space input
  }
};

const waitforfewsecond = async () => {
  await new Promise((resolve) => setTimeout(resolve, 1000));
};

const currentYear = () => {
  const date = new Date().getFullYear();
  return date;
};

const removepresent = (value) => {
  // Check if value contains the '%' symbol and remove it
  return value.includes("%") ? value.replace("%", "") : value;
};
const addpresent = (value) => {
  // Check if value already contains '%' and add it if not present
  // return value && value?.includes("%") ? value : `${value}%`;
  return value && value ? `${value}%` : "-";

};

const getPercentage = (totalvalue, value) => {
  if (totalvalue == 0) {
    return 0;
  }
  const percentage = (value * 100) / totalvalue;
  return percentage.toFixed(0);
};

const laung = localStorage.getItem("laung");

export const navigateToNextTab = (path) => {
  // window.open(`/urxpert_website/${laung}/${path}`, "_blank");
  // window.open(`/urxpert_website_php8/${laung}/${path}`, "_blank");
  window.open(`${process.env.PUBLIC_URL}/${laung || "en"}/${path}`, "_blank");
};

export {
  handleKeyDown,
  notallowspace,
  waitforfewsecond,
  currentYear,
  nomorethenhandread,
  removepresent,
  addpresent,
  getPercentage,
  handleCharactersKeyDown,
  handlePriceKeyDown,
  handleNameKeyDown
};
